export default __webpack_public_path__ + "39e62e83f67b54daa8fdd55e70592471.png";